<template>
  <section class="background is-flex"
           :class="{ 'full-height' : hasAttachments}">
  <div class="item-wrapper is-flex">
    <div class="content-area is-flex">
      <div :id="item.name"
           class="type"
           :class="context"
           v-for="item in icons"
           v-bind:key="item.id"
           @click="setType(item.name)"
           v-bind="getTooltip(item)">
        <div class="icon-container"
             :class="'gtm-create-attachment-'+ item.name.toLowerCase()">
          <span class="icon-graphic"><i :class="item.class" /></span>
        </div>
      </div>
    </div>
  </div>
  </section>
</template>

<script>
import i18n from '@/i18n'
import userAgent from '@/libs/user-agent'

const icons = [
  {
    id: 0,
    name: 'imageorvideo',
    description: 'projectPage.photoVideo',
    image: '/static/icon-photo-video.svg',
    class: 'fal fa-photo-video fa-lg'
  },
  {
    id: 1,
    name: 'whiteboard',
    description: 'projectPage.whiteboard',
    image: '/static/icon-whiteboard.svg',
    class: 'fal fa-chalkboard fa-lg'
  },
  {
    id: 2,
    name: 'link',
    description: 'projectPage.link',
    image: '/static/icon-link.svg',
    class: 'fal fa-link fa-lg'
  },
  {
    id: 3,
    name: 'file',
    description: 'projectPage.file',
    image: '/static/icon-file.svg',
    class: 'fal fa-file fa-lg'
  },
  {
    id: 4,
    name: 'poll',
    description: 'projectPage.poll',
    image: '/static/icon-poll.svg',
    class: 'fal fa-poll-h fa-lg'
  },
  {
    id: 5,
    name: 'iframe',
    description: 'projectPage.iframe',
    image: '/static/icon-iframe.svg',
    class: 'fal fa-browser fa-lg'
  }
]

export default {
  props: ['context', 'hasAttachments'],

  data: function () {
    return {
      isActive: true,
      icons,
      routeTo: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.routeTo = from.fullPath
    })
  },
  computed: {
    isMobile: function () {
      return !userAgent.isApp() && (userAgent.isIOS() || userAgent.isAndroid())
    }
  },
  methods: {
    setType: function (type) {
      this.$emit('setType', type)
    },
    getTooltip: function (item) {
      const tooltip = {}
      if (!this.isMobile) {
        tooltip['data-balloon'] = i18n.t(item.description)
        tooltip['data-balloon-pos'] = 'up'
      }
      return tooltip
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .background {
    overflow: hidden;
    background: $grey-lightest;
    width: 100%;
    min-height: 150px;
    height: 100%;
    align-items: center;
    position: relative;
    overflow: visible;

  }

  .full-height {
    height: 500px;
    @include mobile {
      height: 200px;
    }
  }

  .item-wrapper {
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
    @include mobile {
      margin-left: 1rem;
      max-width: 80%;
      justify-content: space-evenly;
    }
  }

  .ellipse{
    position: absolute;
    top: 2rem;
    right: 2rem;
    color: #fff;
    height: 1.2rem;
  }

  .content-area {
    color: #fff;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
    flex-wrap: wrap;

    @include mobile {
      width: 97%;
      justify-content: space-between;
    }

    .type {
      cursor: pointer;
      // text-transform: uppercase;
      text-align: center;
      .icon-container {
        margin: 1.1rem auto;
        border-radius: 50%;
        -webkit-box-shadow: 2px 5px 5px 0px rgba(136,136,136,0.41);
        -moz-box-shadow: 2px 5px 5px 0px rgba(136,136,136,0.41);
        box-shadow: 2px 5px 5px 0px rgba(136,136,136,0.41);
        background-color: #fff;
        height: 80px;
        width: 80px;
        position: relative;
        @include mobile {
          margin-left: 1.5rem;
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
        }
        @media (min-width: 1792px), (max-width: 1792px) {
          height: 65px;
          width: 65px;
        }
        @include desktop {
          &:hover {
            transform: scale(1.1);
          }
        }
        @include mobile {
          height: 50px;
          width: 50px;
        }

        .icon-graphic {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          color: #363636;
          padding: 2rem;
        }
      }

        .icon-label {
          @include mobile {
            font-size: 0.75rem;
          }
        }
    }
  }

</style>
